export class ImageGalleryItem {
	id?: string;
	label?: string;
	url?: string;
}
